import { render, staticRenderFns } from "./files_viewer.vue?vue&type=template&id=715d53a8&scoped=true&"
import script from "./files_viewer.vue?vue&type=script&lang=js&"
export * from "./files_viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715d53a8",
  null
  
)

export default component.exports